<template>
  <b-carousel-item>
    <slot name="body" />
  </b-carousel-item>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CarouselItemView',
  slotsDefinition: {
    body: {}
  }
};
</script>
